import React from 'react';

import ChooseLogicFilesModal, { filesText } from './chooseLogicFilesModal';

/**
 * Lets the person choose which logic files go into the export. `onExport` gets the chosen names, or null when
 * every file is chosen, which is the export as it was before there was a choice.
 */
export default function ExportConnectionsModal({ open, onClose, onExport, environmentName, files }) {
  return (
    <ChooseLogicFilesModal
      open={open}
      onClose={onClose}
      onConfirm={onExport}
      files={files}
      idPrefix="export"
      title={`Export connections from ${environmentName || 'this environment'}`}
      intro="Choose the logic files to export."
      emptyText="There are no logic files in this environment."
      confirmText={(count) => `Export ${filesText(count)}`}
      busyText="Exporting…"
      progressText={(count) => `Exporting ${filesText(count)}…`}
      errorText="The connections could not be exported. Try again."
      successToast="Connections exported" />
  );
}
